<script lang="scss" setup></script>

<template>
   <div class="internal-job-functions">
      <RouterView></RouterView>
   </div>
</template>
